/**
 * The language of the question "Ask Iris" writes in the user's name (CU-869fkdhjv phase 3, criterion 3).
 *
 * The bubble is the user's own words, so it is in their language, not the interface's: the Iris profile's
 * `lang` wins, then the browser. Spanish, English, Portuguese, French and German have templates (UX Obs. 6;
 * the last three added with Iris's language setting, Curro 2026-10-28); anything else asks in English. Port of the workspace's `chatLang` (`rentacar-ia-workspace/src/chat/questions.js:22`).
 *
 * Pure and alias-free: `node --test` runs it (TL R4).
 */
const SUPPORTED = ['es', 'en', 'pt', 'fr', 'de']

const twoLetters = value => String(value ?? '').trim().slice(0, 2).toLowerCase()

export function chatLang(profileLang, navigatorLang) {
	const own = twoLetters(profileLang)
	if (own) return SUPPORTED.includes(own) ? own : 'en'
	const browser = twoLetters(navigatorLang)
	return SUPPORTED.includes(browser) ? browser : 'en'
}
